import { supplierApiNm } from "pages/Menu4/Supplier/constant"
import { subcontractApiNm } from "constants/subcontractConstant"
import { jobOrderApiNm } from "constants/jobOrderConstant"
import { numberFormat } from "utils"
import { toBahtText } from "utils/toBahtText"
import { branchNoText } from "utils/branchNoText"
import { printWht } from "pages/Menu1/PettyCash/printWht"
import { printWhtNoAgent } from "pages/Menu1/PettyCash/printWhtNoAgent"

export const getDataAndPrintWht = async ({ ax, dialogData, companyData, updLnkSiteAbbr }) => {
  let receiver = { name: "", addr: "", taxId: "" }
  let jobData = { name: "", addr: "", taxId: "" }

  // Handle SupId (supplier) or ScId (subcontract)
  if (dialogData.SupId) {
    const postData = {
      SupId: dialogData.SupId,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    const value = await ax.post(supplierApiNm.getSupplier, postData)
    if (value.data && value.data.length === 1) {
      const data = value.data[0]
      receiver = {
        name: data.Name,
        addr: data.Addr,
        taxId: data.TaxId,
        brchNo: data.BrchNo
      }
      receiver.addr = `${receiver.addr} ${receiver.brchNo >= 0 ? branchNoText(receiver.name, receiver.brchNo) : ""}`
    }
  } else if (dialogData.ScId) {
    const value = await ax.post(subcontractApiNm.getSubcontract, { ScId: dialogData.ScId })
    if (value.data && value.data.length === 1) {
      const data = value.data[0]
      receiver = {
        name: data.Name,
        addr: data.Addr,
        taxId: data.TaxId,
        brchNo: data.BrchNo
      }
      receiver.addr = `${receiver.addr} ${receiver.brchNo >= 0 ? branchNoText(receiver.name, receiver.brchNo) : ""}`
    }
  }

  if (dialogData.JobOrdId && ["A", "C"].includes(dialogData.WhtPayrTyp)) {
    const postData = {
      JobOrdId: dialogData.JobOrdId,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    const value = await ax.post(jobOrderApiNm.getDataForPrintWht, postData)
    if (value.data && value.data.length === 1) {
      const data = value.data[0]
      // // Get receiver from POI data if no SupId or ScId
      // if (!dialogData.SupId && !dialogData.ScId) {
      //   if (data.TakePOIData?.TaxId && data.TakePOIData?.POITypId === 5) {
      //     receiver = {
      //       name: data.TakePOIData.POIName,
      //       addr: data.TakePOIData.Addr,
      //       taxId: data.TakePOIData.TaxId,
      //       brchNo: data.TakePOIData.BrchNo
      //     }
      //   } else if (data.RtnPOIData?.TaxId && data.RtnPOIData?.POITypId === 5) {
      //     receiver = {
      //       name: data.RtnPOIData.POIName,
      //       addr: data.RtnPOIData.Addr,
      //       taxId: data.RtnPOIData.TaxId,
      //       brchNo: data.RtnPOIData.BrchNo
      //     }
      //   } else if (data.LocPOIData?.TaxId && data.LocPOIData?.POITypId === 5) {
      //     receiver = {
      //       name: data.LocPOIData.POIName,
      //       addr: data.LocPOIData.Addr,
      //       taxId: data.LocPOIData.TaxId,
      //       brchNo: data.LocPOIData.BrchNo
      //     }
      //   }
      //   if (receiver.taxId !== "") {
      //     receiver.addr = `${receiver.addr} ${receiver.brchNo >= 0 ? branchNoText(receiver.name, receiver.brchNo) : ""}`
      //   }
      // }
      jobData = {
        name: data.JobData.RcptNm,
        addr: `${data.JobData.RcptAddr} ${data.JobData.RcptBrchNo >= 0 ? branchNoText(data.JobData.RcptNm, data.JobData.RcptBrchNo) : ""}`,
        taxId: data.JobData.RcptTaxId
      }
    }
  }

  const ownAddr = { name: companyData.NameTH, addr: companyData.AddrTH, taxId: companyData.TaxId }
  const amnt = (+dialogData.Amnt) / (1 + +dialogData.VatPrct / 100)
  const wht = amnt * +dialogData.WhtPrct / 100

  const whtData = {
    receiver: receiver,
    amnt: numberFormat(amnt),
    wht: numberFormat(wht),
    whtText: toBahtText(wht),
    whtTyp: dialogData.WhtTypId,
    whtTypOthTxt: dialogData.WhtTypOthTxt || "",
  }

  if (["O", "C"].includes(dialogData.WhtPayrTyp)) {
    if (dialogData.WhtPayrTyp === "O") {
      whtData.payer = ownAddr
    } else {
      whtData.payer = jobData
    }
    whtData.agent = { name: "", addr: "", taxId: "" }
    printWhtNoAgent({ whtData })
  } else {
    whtData.payer = jobData
    whtData.agent = ownAddr
    printWht({ whtData })
  }
}


